import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { TextField } from '@client/new/components/basic';
import { BeforeAfterPhotoModal } from '../primitives/BeforeAfterPhotoModal';
import { FieldLabel } from '../primitives/FieldLabel';
import { MediaDropField } from '../primitives/MediaDropField';
import * as styles from './itemFields.css';
import { ProgramFormValues } from '../../model/programForm.types';

type ReviewItemProps = {
  index: number;
  isSubmitting?: boolean;
};

export const ReviewItem = ({ index, isSubmitting }: ReviewItemProps) => {
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext<ProgramFormValues>();
  const rowErrors = errors.reviews?.[index];
  const [isBeforeAfterOpen, setIsBeforeAfterOpen] = useState(false);

  return (
    <>
      <div className={styles.field}>
        <FieldLabel text="Name" required />
        <TextField
          size="small"
          placeholder="Write"
          disabled={isSubmitting}
          error={!!rowErrors?.name}
          errorMsg={rowErrors?.name?.message}
          inputProps={{ 'data-testid': `program-form-review-${index}-name` }}
          {...register(`reviews.${index}.name`)}
        />
      </div>
      <div className={styles.field}>
        <FieldLabel text="Testimonial" required />
        <TextField
          size="small"
          placeholder="Write testimonial"
          multiline
          minRows={3}
          disabled={isSubmitting}
          error={!!rowErrors?.text}
          errorMsg={rowErrors?.text?.message}
          inputProps={{ 'data-testid': `program-form-review-${index}-text` }}
          {...register(`reviews.${index}.text`)}
        />
      </div>
      <div className={styles.mediaField}>
        <div className={styles.mediaLabelRow}>
          <FieldLabel text="Before/after photo" />
          <button
            type="button"
            className={styles.infoButton}
            onClick={() => setIsBeforeAfterOpen(true)}
            aria-label="Before/after photo information"
            data-testid={`program-form-review-${index}-media-info`}
          >
            <FontAwesomeIcon icon={faInfoCircle} />
          </button>
        </div>
        <Controller
          control={control}
          name={`reviews.${index}.media`}
          render={({ field }) => (
            <div className={styles.mediaBox}>
              <MediaDropField
                value={field.value}
                onChange={field.onChange}
                format="image"
                accept={{ 'image/*': [] }}
                disabled={isSubmitting}
                testId={`program-form-review-${index}-media`}
              />
            </div>
          )}
        />
      </div>
      <BeforeAfterPhotoModal
        isOpen={isBeforeAfterOpen}
        onClose={() => setIsBeforeAfterOpen(false)}
      />
    </>
  );
};
